import { render, staticRenderFns } from "./CellBox.vue?vue&type=template&id=ce36b6fc&scoped=true&"
import script from "./CellBox.vue?vue&type=script&lang=js&"
export * from "./CellBox.vue?vue&type=script&lang=js&"
import style0 from "./CellBox.vue?vue&type=style&index=0&id=ce36b6fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce36b6fc",
  null
  
)

export default component.exports